
<div mat-dialog-title>
  <span>Portfolio Result Explanation</span>
  <button class="close" mat-button data-cancel-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i>
</button>
</div>
<mat-dialog-content>
  <h3 data-portfolio-name [innerText]="'Portfolio: &#34;' + portfolioName + '&#34;'"></h3>

  @if (showRebalanceTable) {
    <h4 class="table-header">General Rebalance Actions</h4>
    <mat-table matSort class="rebalance-action-table" [class]="{'half-height': showSecurityTradeTable}"
      data-rebalance-action-table [dataSource]="rebalanceActionData">
      <ng-container cdkColumnDef="category">
        <mat-header-cell *matHeaderCellDef data-rebalance-action-sort mat-sort-header>Action</mat-header-cell>
        <mat-cell data-action *matCellDef="let row" [innerText]="row.category"></mat-cell>
      </ng-container>
      <ng-container cdkColumnDef="description">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Description</mat-header-cell>
        <mat-cell data-description *matCellDef="let row" [innerText]="row.description"></mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="rebalanceActionColumns; sticky: true"></mat-header-row>
      <mat-row data-rebalance-action-table-row *matRowDef="let row; columns: rebalanceActionColumns"></mat-row>
    </mat-table>
  }

  @if (showSecurityTradeTable) {
    <h4 class="table-header">Security and Trade Action Notes</h4>
    <mat-table matSort class="security-action-table" [class]="{'half-height': showRebalanceTable}"
      data-security-action-table [dataSource]="securityTradeActionNoteData">
      <ng-container cdkColumnDef="securitySymbol">
        <mat-header-cell *matHeaderCellDef data-security-action-sort mat-sort-header>Symb/CSP</mat-header-cell>
        <mat-cell data-symbol *matCellDef="let row" [innerText]="row.securitySymbol"></mat-cell>
      </ng-container>
      <ng-container cdkColumnDef="category">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Exception Reason</mat-header-cell>
        <mat-cell data-exception-reason *matCellDef="let row" [innerText]="row.category"></mat-cell>
      </ng-container>
      <ng-container cdkColumnDef="description">
        <mat-header-cell *matHeaderCellDef mat-sort-header>Explanation</mat-header-cell>
        <mat-cell data-explanation *matCellDef="let row" [innerText]="row.description"></mat-cell>
      </ng-container>
      <mat-header-row *matHeaderRowDef="securityTradeActionNoteColumns; sticky: true"></mat-header-row>
      <mat-row data-security-action-table-row *matRowDef="let row; columns: securityTradeActionNoteColumns"></mat-row>
    </mat-table>
  }
</mat-dialog-content>
<mat-dialog-actions>
  <button data-close-button id="closeButton" (click)="close()" class="btn-medium-primary">Close</button>
</mat-dialog-actions>
